import { Modal as WebModal } from '@thesisedu/web'
import { Modal as AntModal } from 'antd'

export { ModalProps } from '@thesisedu/web'

export const Modal = WebModal as typeof WebModal & {
  confirm: typeof AntModal.confirm
}
Modal.confirm = AntModal.confirm
